export default __webpack_public_path__ + "static/media/roya.7a8e45a0.svg";